export default __webpack_public_path__ + "static/media/user-round.cdfa246d.svg";